import {
  ChartFilterPatternNameEnum,
  CustomControlsNameEnum,
  IDateBoxItem,
  TimeRange,
  TimeRangeEnum
} from '../interfaces';
import Holidays from 'date-holidays'; // TODO: Есть наш сервис по праздникам, может быть нужно выпилить. (как решим чем пользуемся)
import * as moment from 'moment';

const now = new Date();
const NYTimeZoneOffset = 4 * 60 * 60 * 1000; // Когда время переведется на зимнее поменять 4 на 5
const hd = new Holidays();
hd.init('US', 'NY');

export const dateFormat = 'yyyy-MM-dd';
export const dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
export const timeFormat = 'HH:mm';
export const momentDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const momentDateFormat = 'YYYY-MM-DD';

// Если четверг или пятница - то мы позволяем выбрать три предыущих дня, если попадаются выхи - то добавляем еще два (что бы исключить выхи)
// TODO: Учитывать конкретные даты, потому что мы можем попасть на праздник
export const realtimeWorkingDays = now.getDay() === 4 || now.getDay() === 5
  ? now.getTime() - (24 * 60 * 60 * 3 * 1000)
  : now.getTime() - (24 * 60 * 60 * 5 * 1000);

export function disableUnsuitableDates(dateBoxItem: IDateBoxItem): boolean {
  return dateBoxItem.date.getTime() >= new Date().getTime() ||
    dateBoxItem.date.getDay() === 6 ||
    dateBoxItem.date.getDay() === 0;
    // !!hd.isHoliday(dateBoxItem.date); TODO: Пока что выпилили праздники, добавить позже
}

/**
 * Получить локальное время из NY времени (таймзону пользователя)
 * @param date Передаваемая дата NY таймозны
 */
export function getLocalTime(date: string | Date): Date {
  if (!date) return;

  const dateUnix: number = moment(date).unix() * 1000;
  const timeZoneOffset: number = new Date().getTimezoneOffset() * 60 * 1000;
  return new Date(dateUnix + NYTimeZoneOffset - timeZoneOffset);
}

/**
 * Получить время в NY таймзоне
 * @param date Передаваемая дата в таймзоне пользователя
 */
export function getNYTime(date: string | Date): Date {
  if (!date) return;

  const dateUnix: number = moment(date).unix() * 1000;
  const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000 * -1;
  return new Date(dateUnix - (timeZoneOffset + NYTimeZoneOffset));
}

export function dropdownTemplateField(controlName: string): { list: string, input: string } {
  return {
    list: 'description',
    input: controlName !== ChartFilterPatternNameEnum.HV_TERM &&
      controlName !== ChartFilterPatternNameEnum.IVX_TERM &&
      controlName !== CustomControlsNameEnum.IVX_TERM_FIRST &&
      controlName !== CustomControlsNameEnum.IVX_TERM_SECOND &&
      controlName !== ChartFilterPatternNameEnum.MONEYNESS &&
      controlName !== CustomControlsNameEnum.MONEYNESS_FIRST &&
      controlName !== CustomControlsNameEnum.MONEYNESS_SECOND &&
      controlName !== ChartFilterPatternNameEnum.OPTION_TYPE &&
      controlName !== CustomControlsNameEnum.SINGLE_CONTRACT_ANALYZER_TYPE
        ? 'name'
        : 'description'
  };
}

export function isIntraday(timeRange: TimeRange): boolean {
  switch (timeRange) {
    case TimeRangeEnum.D1:
    case TimeRangeEnum.H24:
    case TimeRangeEnum.D3:
      return true;
    case TimeRangeEnum.M1:
    case TimeRangeEnum.M3:
    case TimeRangeEnum.M6:
    case TimeRangeEnum.Y1:
    case TimeRangeEnum.Y5:
    case TimeRangeEnum.ALL:
      return false;
  }
}
